import { RouteRecordRaw } from 'vue-router'

const portsRoutes: RouteRecordRaw[] = [
  {
    path: '/crew/ports',
    name: 'ports.index',
    component: () => import('@/modules/crewing/views/ports/PortsIndex.vue'),
    meta: {
      pageTitle: 'Ports',
      breadcrumbs: ['Ports']
    }
  }
]

export default portsRoutes
